import React from "react";
import { Button, ButtonProps } from "../button/Button";
import { Flex } from "./FlexHelpers";
import { Link } from "../Link";
import { LinkButton } from "../button/LinkButton";
import { TooltipTheOneWrapper } from "../TooltipTheOne";
import { CopyLinkButton } from "./CopyLinkButton";

type LinkWithCopyButtonProps =
{
    url: string,
    extraButtons?: ButtonProps[],
    showAsGoTo?:boolean,
    disabled?:boolean
};

export function LinkWithCopyButton(props: LinkWithCopyButtonProps): JSX.Element 
{
    return (
        
        <Flex flexDirection="row" gap={10} alignItems="center">

            {!props.showAsGoTo &&
                <Link href={props.url} target="_blank" rel="noopener noreferrer">
                    {props.url}
                </Link>
            }

            {props.showAsGoTo &&
                <TooltipTheOneWrapper tooltipContent="Åbn link i ny fane">
                    <LinkButton variant="text" icon="interface_actions_externalLink" href={props.url} target="_blank" rel="noopener noreferrer" />
                </TooltipTheOneWrapper>
            }

            <CopyLinkButton
                url={props.url}
                disabled={props.disabled}
            />
            
            {props.extraButtons && props.extraButtons.map((b, i) =>
                <Button key={i} {...b} />
            )}
        </Flex>
    )
}